import {AuthState} from '@okta/okta-auth-js'
import {PropsWithChildren, createContext} from 'react'

export const AuthContext = createContext<{isReady: boolean; isAuthenticated: boolean; authState: AuthState | null}>({
  isReady: false,
  isAuthenticated: false,
  authState: null,
})

export const AuthProvider: React.FC<PropsWithChildren> = ({children}) => {
  return <Provider>{children}</Provider>
}

const Provider: React.FC<PropsWithChildren> = ({children}) => {
  return children
}
